import useEpdId from 'components/v2/compiler/hooks/useEpdId';
import usePcrV2 from 'components/v2/compiler/hooks/usePcrV2';
import { useCompilerCompositeStatus } from 'services/api/queries';
import { EPDStatusDisplayName } from 'services/EpdClient';

export const usePcrSelectorDialogDeprecatedPcrDisclaimerText = () => {
  const isPcrV2 = usePcrV2();
  const epdId = useEpdId();
  const compositeStatus = useCompilerCompositeStatus(epdId).data;

  if (isPcrV2 || !compositeStatus) {
    return null;
  }

  const isUpdating = compositeStatus.actionsStatus.statusDisplayName === EPDStatusDisplayName.Updating;
  if (isUpdating) {
    return 'After switching to PCR 2019:14 v2, reverting to v1.3.4 is only possible by cancelling the update. Please be aware that cancelling now will require you to re-enter inputs for any future updates.';
  }

  return 'Once you switch to PCR 2019:14 v2, reverting to v1.3.4 will no longer be possible. Your EPD will need to comply with the updated requirements going forward.';
};
